import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_URL + 'api/';

class CampaignService {
  getActiveCampaign(id_user) {
    return axios
      .post(
        API_URL + 'activecampaign',
        { id_user },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return null;
      });
  }

  getCampaignByUid(campaign_uid) {
    return axios
      .get(
        API_URL + 'campaign/' + campaign_uid,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return null;
      });
  }
}

export default new CampaignService();
